import React, {useState, useEffect, useRef} from "react";
import {injectIntl} from "react-intl";
import {connect} from "react-redux";
import PropTypes from "prop-types";

const AssignQuotePopupContentHoc = (props) => {

  const [contentDimensions, setContentDimensions] = useState(null);
  const assContentElement = useRef(null);
  const {windowWidth, children, hideEmployeesList} = props;

  const setCurrentContentDimensions = () => {
    if (assContentElement && assContentElement.current && assContentElement.current.clientWidth) {
      const isMobile = windowWidth < 991;
      setContentDimensions({
        width: isMobile || hideEmployeesList ? assContentElement.current.clientWidth : null,
        height: isMobile || hideEmployeesList ? assContentElement.current.clientHeight : null,
      });
    }
  }

  useEffect(() => {
    setCurrentContentDimensions()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [windowWidth, assContentElement]);

  // console.log("contentWidth", contentWidth);

  return (
    <div className="ass-content" ref={assContentElement}>
      {children(contentDimensions)}
    </div>
  )
};

AssignQuotePopupContentHoc.propTypes = {
  children: PropTypes.func.isRequired,
  hideEmployeesList: PropTypes.bool,
};

const mapStateToProps = (store) => {
  return {
    windowWidth: store.serverState.windowWidth,
  };
};

const mapDispatchToProps = {};

export default injectIntl(
  connect(mapStateToProps, mapDispatchToProps)(AssignQuotePopupContentHoc)
)
